import { convertCompanyResponseToCompany } from './convert/company';
import { convertSimpleJobResponseToSimpleJob } from './convert/job';
import { post } from './http';

import type { Company, CompanyResponse } from '../types/company';
import type { SimpleJob, SimpleJobResponse } from '../types/job';

export type JumpstartRequest = {
    user_id: number;
    company_name: string;
    location: string;
};

export type JumpstartResponse = {
    company: CompanyResponse;
    jobs: SimpleJobResponse[];
};

export type JumpstartResult = {
    company: Company;
    jobs: SimpleJob[];
};

export const createJumpstartCompany = async (
    request: JumpstartRequest
): Promise<JumpstartResult> => {
    const response = await post<JumpstartResponse>('/api/jumpstart', request);

    return {
        company: convertCompanyResponseToCompany(response.company),
        jobs: response.jobs.map(convertSimpleJobResponseToSimpleJob)
    };
};
